import { HStack, Text, VStack } from '@ayble-health/dashboard-components';
import { Box, Center, Flex, useToken } from '@chakra-ui/react';
import { BarChart4 } from 'lucide-react';
import { FoodCard } from '../food/FoodCard';
import type { UserBlockFood } from '../../../models/suspectIdentificationBlockData';

type Props = {
  foods: UserBlockFood[];
};

export const IdentifiedTriggersFoods = ({ foods }: Props) => {
  const [seafoam] = useToken('colors', ['seafoam']);

  return (
    <VStack alignItems={'flex-start'} w={'100%'}>
      <HStack gap={2} alignItems={'center'}>
        <Center bgColor={'shortbread'} borderRadius={'full'} boxSize={'24px'}>
          <BarChart4 color={seafoam} size={14} />
        </Center>

        <Text
          color={'secondary.500'}
          fontWeight={'semibold'}
          fontSize={'sm'}
          letterSpacing={'0.14px'}
        >
          Triggers Identified
        </Text>
      </HStack>

      <Box w={'100%'} mt={3}>
        <Flex flexDir={'row'} overflow={'scroll'} pb={3}>
          {foods.map(({ id, display_name, image_url }) => (
            <FoodCard
              key={id}
              foodId={id}
              foodLabel={display_name}
              imgURL={image_url ?? undefined}
              bgColor={'feather'}
              disableSeverityBar
            />
          ))}
        </Flex>
      </Box>
    </VStack>
  );
};
